import classNames from 'classnames';
import { HTMLAttributes } from 'react';
import { IconBaseProps, IconType } from 'react-icons';
import { VariantProps } from 'tailwind-variants';
import { IsVisible } from '../../../utils';
import { tabItemStyle } from './styles';

interface ITabItemProps
  extends HTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof tabItemStyle> {
  common?: boolean;
  disabled?: boolean;
  icon?: IconType;
  iconProps?: IconBaseProps;
  label?: string;
  orientation?: 'horizontal' | 'vertical';
  selected: boolean;
}

export function TabItem({
  className,
  common,
  design,
  disabled,
  icon: Icon,
  iconOnly = false,
  iconPosition = 'right',
  iconProps,
  label,
  orientation,
  selected,
  textTransform,
  ...rest
}: ITabItemProps) {
  return (
    <button
      className={tabItemStyle({
        design,
        className,
        common,
        orientation,
        selected,
        textTransform,
        iconPosition,
        iconOnly,
        disabled,
      })}
      disabled={disabled}
      {...rest}
      type="button"
    >
      {Icon && (
        <Icon
          className={classNames('', {
            'mx-auto': orientation === 'horizontal',
            '': orientation === 'vertical',
          })}
          size={20}
          {...iconProps}
        />
      )}
      <IsVisible when={!iconOnly}>{label}</IsVisible>
    </button>
  );
}
